<ul class="c-pager" *ngIf="vm.totalItems > vm.pageSize">
	<li class="c-pager__item">
		<a id="openPreviousPageLink" href="javascript:void(0)" class="c-pager__link c-pager__link--prev" (click)="vm.setPreviousPage()">
			<i class="o-icon o-icon--angle" aria-hidden="true"></i>
			<span class="u-sr-only">{{ 'Common.Previous' | translate }}</span>
		</a>
	</li>
	<li class="c-pager__item" *ngIf="vm.currentPage >= 3">
		<a id="openFirstPageLink" href="javascript:void(0)" class="c-pager__link" (click)="vm.setPage(0)">1</a>
	</li>
	<li class="c-pager__item" *ngIf="vm.currentPage >= 3">
		<span href="javascript:void(0)" class="c-pager__link">...</span>
	</li>
	<li class="c-pager__item" *ngIf="vm.currentPage!==0">
		<a href="javascript:void(0)" class="c-pager__link" (click)="vm.setPage(vm.currentPage - 1)">{{ vm.currentPage }}</a>
	</li>
	<li class="c-pager__item">
		<a href="javascript:void(0)" class="c-pager__link c-pager__link--active">{{ vm.currentPage + 1}}</a>
	</li>
	<li class="c-pager__item" *ngIf="vm.currentPage !== vm.numberOfPages() - 1">
		<a href="javascript:void(0)" class="c-pager__link" (click)="vm.setPage(vm.currentPage + 1)">{{ vm.currentPage + 2}}</a>
	</li>
	<li class="c-pager__item" *ngIf="vm.currentPage + 1 !== vm.numberOfPages()">
		<span class="c-pager__link">...</span>
	</li>
	<li class="c-pager__item">
		<a id="openNextPageLink" href="javascript:void(0)" class="c-pager__link c-pager__link--next" (click)="vm.setNextPage()">
			<i class="o-icon o-icon--angle" aria-hidden="true"></i>
			<span class="u-sr-only">{{ 'Common.Next' | translate }}</span>
		</a>
	</li>
</ul>
